import { jsx as h, jsxs as S } from "react/jsx-runtime";
import { c as b } from "react/compiler-runtime";
import { Switch as d } from "@mui/material";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "react";
import "@mui/icons-material";
import "../FormControl/FormControl.js";
import { FormControlLabel as g } from "../FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
import "../../../chunks/index.esm.js";
import "react-dom/server";
import '../../../assets/FilterWrapper.css';import '../../../assets/map.css';/* empty css                   */
import "../Grid/Grid.js";
import "../Paper/Paper.js";
import { Box as w } from "../Box/Box.js";
import "../Radio/Radio.js";
import "../RadioGroup/RadioGroup.js";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "../Menu/Menu.js";
import "../MenuItem/MenuItem.js";
import { Typography as _ } from "../Typography/Typography.js";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Warning";
import "@mui/material/styles";
import "../Table/Table.js";
import "../TableBody/TableBody.js";
import "../TableHead/TableHead.js";
import "../TableRow/TableRow.js";
import "../TableCell/TableCell.js";
import "../ToggleButton/ToggleButton.js";
import "../ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../Stepper/Stepper.js";
import "../Step/Step.js";
import "../StepLabel/StepLabel.js";
import "../Link/Link.js";
import "../LoadingButton/LoadingButton.js";
import "../LinearProgress/LinearProgress.js";
import "../Stack/Stack.js";
import "../Card/Card.js";
import "../CardActions/CardActions.js";
import "../FormHelperText/FormHelperText.js";
import "../AccordionDetails/AccordionDetails.js";
import "../TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/icons-material/Close";
import "@mui/material/Typography";
import "@mui/material/Dialog";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../../molecules/Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../../molecules/NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/Search";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "@mui/icons-material/Menu";
import "../../organisms/SunburstGraph/SunburstGraph.js";
import "../../organisms/RadarGraph/RadarGraph.js";
import "../../organisms/ScoreGauge/ScoreGauge.js";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../../organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../../organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "@mui/icons-material/ArrowForward";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "../../organisms/ReactMap/index.js";
import "@mui/material/Button";
import "../../organisms/ReactMap/GMapStatic.js";
import "@mui/icons-material/Clear";
import { styles as y } from "./Switch.styles.js";
function ao(x) {
  const t = b(22);
  let i, m, o, r;
  t[0] !== x ? ({
    label: i,
    startLabel: o,
    sx: r,
    ...m
  } = x, t[0] = x, t[1] = i, t[2] = m, t[3] = o, t[4] = r) : (i = t[1], m = t[2], o = t[3], r = t[4]);
  let a;
  t[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = {
    display: "flex",
    alignItems: "center",
    gap: "6px"
  }, t[5] = a) : a = t[5];
  let p;
  t[6] !== o ? (p = o && /* @__PURE__ */ h(_, { sx: {
    fontSize: "12px",
    fontWeight: 400
  }, children: o }), t[6] = o, t[7] = p) : p = t[7];
  let c;
  t[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = {
    "aria-label": "controlled"
  }, t[8] = c) : c = t[8];
  let e;
  t[9] !== r ? (e = Array.isArray(r) ? r : [r], t[9] = r, t[10] = e) : e = t[10];
  let l;
  t[11] !== e ? (l = [y.switchStyles, ...e], t[11] = e, t[12] = l) : l = t[12];
  let s;
  t[13] !== m || t[14] !== l ? (s = /* @__PURE__ */ h(d, { inputProps: c, sx: l, ...m }), t[13] = m, t[14] = l, t[15] = s) : s = t[15];
  let f;
  t[16] !== i || t[17] !== s ? (f = /* @__PURE__ */ h(g, { control: s, label: i, sx: y.labelStyles }), t[16] = i, t[17] = s, t[18] = f) : f = t[18];
  let n;
  return t[19] !== p || t[20] !== f ? (n = /* @__PURE__ */ S(w, { sx: a, children: [
    p,
    f
  ] }), t[19] = p, t[20] = f, t[21] = n) : n = t[21], n;
}
export {
  ao as Switch
};
